import React, {useState, useEffect} from 'react';
import {Form, Button, Row, Col} from 'react-bootstrap';
import UploadImage from '../../client/components/ImageUpload';
import { default as ReactSelect } from "react-select";
import { useSelector } from 'react-redux';
import axios from 'axios'

export default function EditStore({id, close}) {
    const {user}=useSelector((state)=> state.auth);
    const sellerId = user.seller_profile_id;
    const [email, setEmail] = useState();
    const [storeName, setStoreName] = useState();
    const [number, setNumber] = useState();
    const [alternativeNumber, setAlternativeNumber] = useState();
    const [address, setAddress] = useState();
    const [timings, setTimings] = useState();
    const [openingDays, setOpeningDays] = useState([]);
    const [days, setDays] = useState([]);
    const [typeId, setTypeId] = useState();
    const [location, setLocation] = useState();

    const Select = (props) => {
        return (
            <div>
                <Select {...props}>
                    <input
                        type=""
                        checked={props.isSelected}
                        onChange={() => null}
                    />{" "}
                    <label>{props.label}</label>
                </Select>
            </div>
        );
    };
    const daysOptions = [
        { value: "mon", label: "Mon" },
        { value: "tue", label: "Tue" },
        { value: "wed", label: "Wed" },
        { value: "thur", label: "Thu" },
        { value: "fri", label: "Fri" },
        { value: "sat", label: "Sat" },
        { value: "sun", label: "Sun" }
    ];
    const handleChange = (selected) => {
        const selectDays = selected.map((day) => day.value)
        setOpeningDays(selected);
        setDays(selectDays)
    }

    useEffect(()=> {
        const getStoreInfo = async(id)=> {
            await axios.get(process.env.REACT_APP_FIND_API_URL + `/store/get-store/${id}`, {withCredentials: true}).then((res)=> {
                setEmail(res.data[0].seller_store_email)
                setStoreName(res.data[0].seller_store_name)
                setNumber(res.data[0].seller_store_number)
                setAddress(res.data[0].seller_store_address)
                setAlternativeNumber(res.data[0].seller_store_alternative_number)
                setTimings(res.data[0].seller_store_tmings)
                const storeDays = res.data[0].seller_store_days;
                const arr = JSON.parse(storeDays)
                setOpeningDays(arr.map(i => ({ value: i, label: i })))
                setTypeId(res.data[0].seller_type_id)
            })
        }
        getStoreInfo(sellerId)
    }, [sellerId]);

    useEffect(()=> {
        navigator.geolocation.getCurrentPosition((props)=> {
            setLocation([props.coords.latitude,props.coords.longitude])
        })
    }, []);
    const shop_location = JSON.stringify(location);
    const opening_days = JSON.stringify(days);

    const handleEdit = async(e)=> {
        e.preventDefault();
        try {
            const res = await axios.patch(process.env.REACT_APP_FIND_API_URL + `/store/update`, {
                seller_shop_id: id,
                seller_profile_id: sellerId,
                seller_type_id: typeId,
                seller_store_name: storeName,
                seller_store_address: address,
                seller_store_email: email,
                seller_store_number: number,
                seller_store_alternative_number: alternativeNumber,
                seller_store_days: opening_days,
                seller_store_tmings: timings,
                seller_store_map_location: shop_location
            }, {withCredentials: true})
            if(res.data){
                close()
            }
        } catch (error) {
            console.log(error);
        }
    }
      
    return (
        <Form onSubmit={handleEdit}>
            <Row className="mb-3">
                <Col md="6">
                    <Form.Group className="mb-3">
                        <Form.Label>Store Name</Form.Label>
                        <Form.Control type="text" placeholder="Enter Store Name" value={storeName} onChange={(e) => setStoreName(e.target.value)} />
                    </Form.Group>
                </Col>
                <Col md="6">
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label>Email address</Form.Label>
                        <Form.Control type="email" placeholder="Enter email" value={email} onChange={(e) => setEmail(e.target.value)} />
                    </Form.Group>
                </Col>
                <Col md={12}>
                    <Form.Group className="mb-3">
                        <Form.Label>Address</Form.Label>
                        <Form.Control type="text" placeholder="Enter Address" value={address} onChange={(e) => setAddress(e.target.value)} />
                    </Form.Group>
                </Col>
                <Col md="6">
                    <Form.Group className="mb-3">
                        <Form.Label>Phone Number</Form.Label>
                        <Form.Control type="number" placeholder="Enter Phone Number" value={number} onChange={(e) => setNumber(e.target.value)} />
                    </Form.Group>
                </Col>
                <Col md="6">
                    <Form.Group className="mb-3">
                        <Form.Label>Alternative Number</Form.Label>
                        <Form.Control type="number" placeholder="Enter Phone Number" value={alternativeNumber} onChange={(e) => setAlternativeNumber(e.target.value)} />
                    </Form.Group>
                </Col>
                <Col md="6">
                    <Form.Group className="mb-3">
                        <Form.Label>Opening Days</Form.Label>
                        <ReactSelect
                            classNamePrefix='react-select-container'
                            options={daysOptions}
                            isMulti
                            closeMenuOnSelect={false}
                            hideSelectedOptions={false}
                            components={{
                                Select
                            }}
                            onChange={handleChange}
                            allowSelectAll={true}
                            value={openingDays}
                        />
                    </Form.Group>
                </Col>
                <Col md="6">
                    <Form.Group className="mb-3">
                        <Form.Label>Opening Timings</Form.Label>
                        <Form.Control type="text" placeholder="e.g 9am-5pm" value={timings} onChange={(e) => setTimings(e.target.value)} />
                    </Form.Group>
                </Col>
                <Col md="12">
                    <UploadImage title="logo" />
                </Col>
            </Row>
            <div>
                <Button variant="primary" type="submit" className="w-100">
                    Submit
                </Button>
            </div>
        </Form>
    )
}